import React, { useEffect, useState } from 'react';
import api from '../../api';

const ENTITY_LABELS = {
    user: 'User',
    proposal: 'Proposal',
    contract: 'Contract',
    invoice: 'Invoice',
    payment: 'Payment',
    client: 'Client',
    document: 'Document',
};

const ACTION_COLORS = {
    created: 'bg-emerald-50 text-emerald-700',
    updated: 'bg-blue-50 text-blue-700',
    deleted: 'bg-red-50 text-red-700',
    archived: 'bg-gray-100 text-gray-600',
    sent: 'bg-indigo-50 text-indigo-700',
    viewed: 'bg-sky-50 text-sky-700',
    accepted: 'bg-emerald-50 text-emerald-700',
    password_reset_by_admin: 'bg-amber-50 text-amber-700',
    password_changed: 'bg-amber-50 text-amber-700',
};

export default function AuditLogSettings() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState('');

    useEffect(() => {
        api.get('/activity', { params: { limit: 200 } })
            .then(r => setItems(r.data.items || []))
            .finally(() => setLoading(false));
    }, []);

    const filtered = items.filter(i => {
        if (!filter) return true;
        const blob = `${i.entity_type} ${i.action} ${i.actor_name} ${JSON.stringify(i.meta || {})}`.toLowerCase();
        return blob.includes(filter.toLowerCase());
    });

    return (
        <div className="bg-white rounded-xl border border-[color:var(--bm-border)] p-6 max-w-5xl">
            <div className="flex items-center justify-between gap-3 mb-4 flex-wrap">
                <div>
                    <div className="font-display text-[15px] font-semibold text-[color:var(--bm-text)]">Audit log</div>
                    <div className="text-[12px] text-[color:var(--bm-text-muted)] mt-1">Recent 200 events across HQ — user changes, proposals, contracts, invoices and payments.</div>
                </div>
                <input
                    placeholder="Filter…"
                    value={filter}
                    onChange={e => setFilter(e.target.value)}
                    className="h-9 px-3 rounded-md border border-[color:var(--bm-border)] bg-white text-[13px] w-56"
                    data-testid="audit-filter-input"
                />
            </div>

            {loading && <div className="text-[12.5px] text-[color:var(--bm-text-muted)]">Loading…</div>}
            {!loading && filtered.length === 0 && <div className="text-[12.5px] text-[color:var(--bm-text-muted)]">No activity matches your filter.</div>}

            <div className="space-y-1.5" data-testid="audit-log-list">
                {filtered.map(i => (
                    <div key={i.id} className="flex items-start gap-3 py-2 border-b border-[color:var(--bm-border)]/60 last:border-0 text-[12.5px]">
                        <div className="w-32 shrink-0 text-[color:var(--bm-text-muted)] text-[11.5px]">
                            {new Date(i.timestamp).toLocaleString('en-GB', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}
                        </div>
                        <div className="w-24 shrink-0">
                            <span className="inline-block px-1.5 py-0.5 rounded text-[10.5px] font-semibold bg-[color:var(--bm-bg-mute)] text-[color:var(--bm-text-muted)]">
                                {ENTITY_LABELS[i.entity_type] || i.entity_type}
                            </span>
                        </div>
                        <div className="w-32 shrink-0">
                            <span className={`inline-block px-1.5 py-0.5 rounded text-[10.5px] font-semibold ${ACTION_COLORS[i.action] || 'bg-gray-100 text-gray-700'}`}>
                                {i.action}
                            </span>
                        </div>
                        <div className="flex-1 min-w-0">
                            <span className="font-medium">{i.actor_name || '—'}</span>
                            {i.meta && Object.keys(i.meta).length > 0 && (
                                <span className="text-[color:var(--bm-text-muted)]"> · {Object.entries(i.meta).map(([k, v]) => `${k}=${typeof v === 'object' ? JSON.stringify(v) : v}`).join(', ')}</span>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
